
import Vue from 'vue'

export default ({id}, { commercialAgreements, rejetcAgreementComment: comment}) => {
  const setNumber = ({checked, reject}) => {
    return checked ? 1 : reject ? -1 : 0
  }
  const requirements = {
    comment,
    has_catalog_and_commercial_agreements: setNumber(commercialAgreements[0]),
    has_sinister_number: setNumber(commercialAgreements[1]),
    has_sinister_date: setNumber(commercialAgreements[2]),
    has_inbursa_chaining_and_reporting: setNumber(commercialAgreements[3]),
  }
  let p1 = () => Vue.$http.put(`/sinisters/affected/commercial-agreements/${id}/`, requirements)
  let p2 = () => commercialAgreements.some(({reject, lastStatus}) => reject && lastStatus !== -1) ? Vue.$http.put(`/sinisters/affected/reject-commercial-agreements/${id}/`, requirements) : null
  return Promise.all([p1(), p2()])
}


// WEBPACK FOOTER //
// ./src/services/purchase/sendCommercialAgreements.js